import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

import { Artefact, ARTEFACT_TYPE_META } from "@/types/artefacts";
import { useArtefactActions } from "@/hooks/useArtefactActions";

import { ArtefactActions } from "./ArtefactActions";

interface ArtefactHeaderProps {
  artefact: Artefact;
}

export const ArtefactHeader: React.FC<ArtefactHeaderProps> = ({ artefact }) => {
  const typeMeta = ARTEFACT_TYPE_META[artefact.type];
  const { formatTimestamp } = useArtefactActions();

  return (
    <div className="flex items-start justify-between mb-4">
      <div className="flex items-center gap-3">
        <div className={`p-3 rounded-xl bg-default-100 ${typeMeta.color}`}>
          <Icon height={20} icon={typeMeta.icon} width={20} />
        </div>

        <div>
          <h2 className="text-lg font-semibold text-black dark:text-white">{artefact.title}</h2>
          <div className="flex items-center gap-3 text-xs text-default-500">
            <span>{typeMeta.label}</span>
            <span>•</span>
            <span>{formatTimestamp(artefact.timestamp)}</span>
            {artefact.metadata?.estimatedSize && (
              <>
                <span>•</span>
                <span>{artefact.metadata.estimatedSize}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <ArtefactActions artefact={artefact} />
    </div>
  );
};
